import React from "react";
import { Line } from "react-chartjs-2";
import "../IncomeDashboard.css";

export const IncomeChart = ({chartData}) => {
  const data = {
    labels: chartData ? chartData.labels : [],
    datasets: chartData ? chartData.datasets : []
  };
  return (
    <React.Fragment>
      <div className="incomeInfoMaincard">
        <h3 className="incomecardheading" style={{textAlign:"center", fontSize:"16px"}}>Gross Monthly Income</h3>
        <div style={{ marginTop: "1rem" }}>
          <Line
            data={data}
            height={80}
            options={{
              legend: {
                display: true,
              },
               tooltips: {
                callbacks: {
                  label: function (tooltipItem, chartData) {
                    const datasetLabel = chartData.datasets[tooltipItem.datasetIndex].label || "";
                    const value = tooltipItem.yLabel;
                    const formattedValue = new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(value);
                    return `${datasetLabel}: ${formattedValue}`;
                  },
                },
              },

              scales: {
                xAxes: [
                  {
                    stacked: true,
                    gridLines: {
                      color: "rgba(0, 0, 0, 0)",
                    },
                  },
                ],
                yAxes: [
                  {
                    stacked: true,
                    ticks: {
                      beginAtZero: true,
                      callback: function (value) {
                        return new Intl.NumberFormat('en-US', {
                          style: 'currency',
                          currency: 'USD',
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(value);
                      }
                    },
                    gridLines: {
                      color: "rgba(0, 0, 0, 0)",
                    },
                  },
                ],
              },
              plugins: {},
            }}
          />
        </div>
      </div>
    </React.Fragment>
  );
};
